import { restApiMP } from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApiMP.post("/api/wip", params);
};

const upsert = data => {
  return restApiMP.post("/api/wip/save", data);
};

const remove = ids => {
  return restApiMP.delete(`/api/wip`, { data: ids });
};

const getAllForCSV = params => {
  return restApiMP.post("/api/wip/csv", params);
};

const wipService = {
  getAll,
  getAllForCSV,
  upsert,
  remove
};

export default wipService;